// $(document).ready(function() {
//     setTimeout(function() {
//         $('[data-present-slider]').slick({
//             autoplay       : true,
//             slidesToShow   : 1,
//             slidesToScroll : 1,
//             infinite       : false,
//             arrows         : false,
//             dots           : true,
//         });
//     }, 1000);
// });

export default class AdventCalender {
    constructor($wrapper) {
        this.$adventPackages = $wrapper.querySelectorAll('[data-advent-date]');
        this.$calender = $wrapper.querySelector('[data-advent-calender]');
        this.$playSong = $wrapper.querySelector('[data-play-song]');
        this.$closeButton = $wrapper.querySelector('[data-close-advent-contest-content]');
        this.$presentSlider = $wrapper.querySelector('[data-present-slider]');
        this.data = JSON.parse($wrapper.querySelector('[data-advent-calender-data]').innerHTML);

        this.adventItemClicked = this.adventItemClicked.bind(this);
        this.closeAdventContent = this.closeAdventContent.bind(this);
        this.playSong = this.playSong.bind(this);

        this.$adventPackages.forEach($package => $package.addEventListener('click',(e) => { e.preventDefault(); this.adventItemClicked($package) }));
        if(this.$closeButton) {
            this.$closeButton.addEventListener('click', this.closeAdventContent);
        }

        if(this.$playSong) {
            this.song = new Audio('/themes/njam-2/js/JingleBellRock.mp3');
            this.$playSong.addEventListener('click', this.playSong);
        }

        if(this.$presentSlider) {
            setTimeout(() => {
                    new Swiper(this.$presentSlider, {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        loop: true,
                        autoplay: true,
                        autoHeight: true,
                        pagination: {
                            el: ".swiper-pagination",
                        },
                    });
            }, 1000);
        }

        // remove opacity
        this.$adventPackages.forEach( $package => {
            if (this.data[$package.dataset.adventDate] && this.data[$package.dataset.adventDate].active === true) {
                $package.querySelectorAll('.advent-calender-v2__star__image').forEach($child => {
                    $child.style.opacity = 1
                });
            }


            $package.querySelectorAll('.advent-calender-v2__star__image').forEach($child => {
                $child.setAttribute('data-tooltip', this.data[$package.dataset.adventDate] ? this.data[$package.dataset.adventDate].title : 'Oei, dit cadeautje is nog niet aangekomen. Kom op ' + $package.dataset.adventDate + ' nog een keertje terug')
                $child.setAttribute('data-position', 'center top');
            });
        });

        new Tooltip({
            theme: "light", // Selects one of the pre-defined tooltip styles - light or dark.
            distance: 10,    // Specifies the distance in pixels from trigger to tooltip.
            delay: 0        // Specifies how long the tooltip remains visible (in ms) after the mouse leaves the trigger.
        });
    }

    adventItemClicked($package) {
        var link = this.data[$package.dataset.adventDate].href;

        if (link) {
            window.location.href = link;
        }
    };

    closeAdventContent(e) {
        e.preventDefault();
        this.$calender.removeClass('advent-calender--hidden');
        this.$closeButton.remove();
    };

    playSong(e) {
        if(song.paused) {
            this.$playSong.setAttribute("class", "nose nose--playing");
            this.song.play()
        } else {
            this.$playSong.setAttribute("class", "nose");
            this.song.pause();
        }
    };
}